<div class="user-settings">
    <header class="page-header">
        <div class="row">
            <div class="col-md-4">
                <h2 class="title pull-left">Settings</h2>
            </div>
        </div>
    </header>

    <div class="margin-top-20">
        <dx-tab-panel [elementAttr]="{ class: 'sp-dx-tab-panel' }" [swipeEnabled]="false">
            <dxi-tab-panel-item title="Notifications">
                <div *dxTemplate>
                    <sp-user-settings-notification-tab-display></sp-user-settings-notification-tab-display>
                </div>
            </dxi-tab-panel-item>
        </dx-tab-panel>
    </div>
</div>